import { compact, get } from "lodash"
import { numberFormatter } from "helpers/formatters/numbers"

const QUERY = `query ($modelId: String!, $contentSetId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!) {
  model(id: $modelId) {
    simulation(positionSet: $positionSet, base: $base, from: $from, to: $to) {
      exposure(contentSetId: $contentSetId) {
        date
        factors {
          id
          name
          category
          net
        }
      }
    }
  }
}`

export function createContentSetExposureMultiDateQuery(modelId, contentSetId, positionSet, base, from, to) {
  return {
    key: compact(["content-set", contentSetId, "exposure", "multiDate", modelId, positionSet, base, from, to]),
    query: QUERY,
    variables: {
      contentSetId,
      modelId,
      positionSet,
      base,
      from,
      to,
    },
    select: (graphqlResult) => {
      const exposure = get(graphqlResult, "data.model.simulation.exposure", [])
      return {
        values: {
          formatter: numberFormatter,
          dates: exposure.map(({ date, ...dateData }) => {
            const factors = dateData.factors.reduce((acc, { id, net }) => {
              acc[id] = net
              return acc
            }, {})

            return {
              date,
              ...factors,
            }
          }),
        },
      }
    },
  }
}
